import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const fetchContractReportData = createApi('api/reports', 'GET');

const ContractReport = createSlice({
  name: 'ContractReport',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContractReportData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContractReportData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchContractReportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ContractReport.reducer;